<template>
  <v-container>
    <v-row>
      <v-col class="text-center">
        <v-img :src="require('@/assets/image/notFound.jpg')" width="500" class="mx-auto">
        </v-img>
      </v-col>
      <v-col cols="12" class="text-center">
        <span class="text-subtitle-1 text-md-h4 font-weight-black">
          서비스에 이용에 불편을 드려 죄송합니다.<br>
          요청하신 페이지를 찾을 수 없습니다.
        </span>
      </v-col>
      <v-col cols="12" class="text-center">
        <p class="word_keep font-weight-medium">
          요청하신 페이지의 주소가 잘못 입력되었거나,<br><br>
          페이지 주소의 변경 혹은 삭제로 인해 현재 사용하실 수 없습니다.<br><br>
          입력하신 페이지의 주소가 정확한지 다시 한번 확인 해주시기 바랍니다.
        </p>
      </v-col>
      <v-col class="text-center">
        <v-btn @click="back()" color="primary">이전페이지</v-btn>
        <v-btn @click="goMain()" color="primary" class="ml-4">메인으로</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    back () {
      this.$router.go(-1)
    },
    goMain () {
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>
.word_keep {
  word-break: keep-all;
}
</style>
